import React from 'react';
import { styled } from '@mui/material/styles';
import BaseBanner from '../core/BaseBanner';
import BannerWithDismissal from '../core/BannerWithDismissal';
import { DismissibleBannerProps } from '../types';

const StyledFloatingBanner = styled(BaseBanner)(({ theme }) => ({
  position: 'fixed',
  bottom: 20,
  left: '50%',
  transform: 'translateX(-50%)',
  boxShadow: theme.shadows[8],
  zIndex: 1400,
  width: '90vw',
  
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    minWidth: '50vw',
    maxWidth: '800px',
  },
}));

const FloatingBanner: React.FC<DismissibleBannerProps> = props => {
  return (
    <BannerWithDismissal {...props}>
      {({ isDismissed, onDismiss, actionButton }) => {
        if (isDismissed) return null;
        
        const isDismissible = !props.persistent;
        
        return (
          <StyledFloatingBanner
            {...props}
            onDismiss={onDismiss}
            showCloseButton={isDismissible}
            actionButton={actionButton}
          />
        );
      }}
    </BannerWithDismissal>
  );
};

export default FloatingBanner; 